const styles = (theme) => ({
  root: {
    width: '100%',
    height: 'auto',
  },
})

export default styles
